import { ImageUploader } from "./image-uploader.js";

export class ResizableImageUploader extends ImageUploader {
    constructor(inputElement, options = {}) {
        super(inputElement, options);
    }

    resize(width, height) {
        this.setSize(width, height);
    }
}